"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4383],{

/***/ 7171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M0": function() { return /* binding */ LandingWhiteSec; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "kj": function() { return /* binding */ LandingGreySecWrap; },
/* harmony export */   "zq": function() { return /* binding */ LandingGreySec; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);

var Flex = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__Flex",
  componentId: "sc-1i94ptm-0"
})(["display:flex;align-items:center;"]);
var LandingGreySec = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__LandingGreySec",
  componentId: "sc-1i94ptm-1"
})(["background:#f5f5f5;padding:", ";margin-top:-120px;margin-bottom:", ";@media only screen and (max-width:768px){padding:", ";margin-top:", ";}"], function (props) {
  return props.padding;
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.padding || "16px";
}, function (props) {
  return props.marginTop || "0px";
});
var LandingGreySecWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__LandingGreySecWrap",
  componentId: "sc-1i94ptm-2"
})(["width:1200px;margin:0 auto;background:#f5f5f5;@media only screen and (max-width:768px){width:100%;}"]);
var LandingWhiteSec = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__LandingWhiteSec",
  componentId: "sc-1i94ptm-3"
})(["width:1200px;margin:0 auto;background:#fff;padding:", ";@media only screen and (max-width:768px){width:100%;padding:16px;}"], function (props) {
  return props.padding;
});

/***/ }),

/***/ 2434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$5": function() { return /* binding */ LandingCurrDelParent; },
/* harmony export */   "Ix": function() { return /* binding */ LandingCurrDelInfo; },
/* harmony export */   "Mz": function() { return /* binding */ LandingCurrDelWrap; },
/* harmony export */   "Ob": function() { return /* binding */ FootNote; },
/* harmony export */   "PW": function() { return /* binding */ PoweredByText; },
/* harmony export */   "QU": function() { return /* binding */ LandingCurrDelList; },
/* harmony export */   "iq": function() { return /* binding */ LandingCurrDelLeft; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "kc": function() { return /* binding */ LandingCurrDel; },
/* harmony export */   "nb": function() { return /* binding */ LandingCurrDelTitle; },
/* harmony export */   "oX": function() { return /* binding */ LandingCurrDelpara; }
/* harmony export */ });
/* unused harmony exports CheckBtn, LandingCurrDelFlex, LandingCurrDelCity */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);

var LandingCurrDelParent = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelParent",
  componentId: "sc-1nuhlke-0"
})(["background:#000;margin-top:-1px;"]);
var LandingCurrDel = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDel",
  componentId: "sc-1nuhlke-1"
})(["background:#ffffff;position:relative;border-radius:16px;left:0px;right:0px;bottom:24px;display:flex;padding:34px 16px;width:100%;bottom:-60px;& input{background:#ffffff;border:1px solid #d2d2d2;border-radius:4px;margin-right:8px;padding:10px;font-weight:400;font-size:16px;line-height:19px;}& input.disable{opacity:0.3;pointer-events:none;}input.focus{outline:none;border:1px solid #008cff !important;}& input.error{border:1px solid red;}.curr1,.curr2,.curr3{position:absolute;width:92px;height:92px;transform:rotate(45deg);}& .curr1{top:82px;left:9px;z-index:7;}& .curr2{top:82px;left:35px;z-index:6;}& .curr3{top:82px;left:58px;z-index:5;}"]);
var Flex = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__Flex",
  componentId: "sc-1nuhlke-2"
})(["display:flex;align-items:center;"]);
var LandingCurrDelWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelWrap",
  componentId: "sc-1nuhlke-3"
})(["display:flex;margin:0 auto;background:#fff;flex-direction:column;"]);
var LandingCurrDelLeft = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelLeft",
  componentId: "sc-1nuhlke-4"
})(["background:linear-gradient( 159.48deg,#e3fffd 4.69%,rgba(230,237,255,0.736176) 27.76%,#d6e8f4 92.13% );border-radius:14px;padding:24px;margin-bottom:32px;position:relative;"]);
var LandingCurrDelTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h3.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelTitle",
  componentId: "sc-1nuhlke-5"
})(["font-family:\"Raleway\";font-style:normal;font-weight:500;font-size:28px;line-height:36px;width:100%;color:#000000;margin-bottom:32px;"]);
var CheckBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].button.withConfig({
  displayName: "LandingCurrDelstyle__CheckBtn",
  componentId: "sc-1nuhlke-6"
})(["background:#ffffff;box-shadow:0px 1px 7px rgba(0,0,0,0.21);border-radius:6px;font-weight:900;font-size:16px;line-height:20px;color:#000;outline:none;border:none;cursor:pointer;width:102px;height:40px;flex-shrink:0;display:flex;align-items:center;justify-content:center;"]);
var LandingCurrDelFlex = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelFlex",
  componentId: "sc-1nuhlke-7"
})(["display:flex;position:relative;height:120px;& img{width:122px;height:122px;flex-shrink:0;position:absolute;}& img:first-child{z-index:3;left:0;}& img:nth-child(2){z-index:2;left:21px;top:1px;}& img:last-child{z-index:1;left:54px;top:-3px;}"]);
var LandingCurrDelInfo = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelInfo",
  componentId: "sc-1nuhlke-8"
})(["font-family:\"Open Sans Light\",sans-serif;font-weight:400;color:#4a4a4a;margin-bottom:24px;font-size:16px;line-height:24px;font-style:normal;width:100%;& .bold{font-weight:700;}"]);
var LandingCurrDelCity = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelCity",
  componentId: "sc-1nuhlke-9"
})(["font-family:\"Open Sans Light\",sans-serif;font-weight:400;font-size:16px;line-height:24px;color:#4a4a4a;position:relative;margin-bottom:8px;&:after{content:\"\";position:absolute;background:#d9d9d9;border-radius:15px;width:40px;height:4px;top:-4px;left:0;}em{color:#22936a;margin-bottom:8px;font-weight:700;font-style:normal;}"]);
var LandingCurrDelpara = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelpara",
  componentId: "sc-1nuhlke-10"
})(["font-family:\"Avenir\";font-style:normal;font-weight:500;font-size:18px;line-height:24px;color:#000000;margin-bottom:110px;"]);
var LandingCurrDelList = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].ul.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelList",
  componentId: "sc-1nuhlke-11"
})(["font-size:14px;line-height:20px;line-height:32px;padding-left:18px;gap:10px;margin-bottom:12px;& li{position:relative;}& li:after{content:\"\";position:absolute;width:5px;height:14px;left:-18px;top:9px;background:#a07419;border-radius:14px;}& .yellowText{background:linear-gradient(86.88deg,#9d8523 0%,#dab90b 100%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;font-weight:700;}& .greenText{background:linear-gradient(93.66deg,#249083 0%,#249054 100%),#ffffff;-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;font-weight:700;}& .bold{background:linear-gradient(0deg,#000000,#000000),linear-gradient(93.66deg,#249083 0%,#249054 100%),#ffffff;-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;font-weight:700;}"]);
var FootNote = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(Flex).withConfig({
  displayName: "LandingCurrDelstyle__FootNote",
  componentId: "sc-1nuhlke-12"
})(["position:absolute;bottom:38px;"]);
var PoweredByText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
  displayName: "LandingCurrDelstyle__PoweredByText",
  componentId: "sc-1nuhlke-13"
})(["font-family:\"Open Sans Light\",sans-serif;font-weight:400;font-size:12px;line-height:16px;color:#000000;margin-right:20px;"]);

/***/ }),

/***/ 4383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ insuranceSection; }
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 8 modules
var hooks = __webpack_require__(7510);
// EXTERNAL MODULE: ../../libs/ui/src/lib/shared-styled-components/index.ts
var shared_styled_components = __webpack_require__(7171);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/LandingButton/LandingButton.tsx + 1 modules
var LandingButton = __webpack_require__(1893);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/LandingFeatures/LandingFeatures.style.ts

var LandingFeaturesStyled = styled_components_browser_esm["default"].section.withConfig({
  displayName: "LandingFeaturesstyle__LandingFeaturesStyled",
  componentId: "sc-1m37zrn-0"
})(["background:#ffffff;border-radius:16px;padding:36px 40px 70px;flex:1;position:relative;display:flex;flex-direction:column;height:500px;& .greenText{color:#0b8041;font-weight:700;}.lug1,.lug2,.shield,.shieldRect,.coins,.moneyBag,.app1,.app2,.featureVector1,.featureVector2{position:absolute;}& .lug2{width:70px;height:134px;right:191px;bottom:104px;z-index:2;}& .lug1{width:41px;height:148px;right:17px;bottom:104px;z-index:2;}& .shield{width:85px;height:85px;right:80px;bottom:103px;z-index:5;opacity:0;transform:scale(0.5);}& .shieldRect{width:143px;height:28px;position:absolute;right:50px;bottom:96px;z-index:4;opacity:0;}& .coins{width:67px;height:70px;right:40px;bottom:97px;z-index:3;opacity:0;}& .moneyBag{width:85px;height:116px;right:11px;bottom:121px;z-index:2;}& .app1{width:120px;height:30px;right:83px;bottom:194px;z-index:4;opacity:0;}& .app2{width:130px;height:30px;right:105px;bottom:109px;z-index:4;opacity:0;}& .featureVector{width:176px;height:135px;position:absolute;bottom:70px;right:0;z-index:1;}& .featureVector2{width:208px;height:135px;position:absolute;bottom:70px;right:0;z-index:1;}}"]);
var LandingFeaturesTitle = styled_components_browser_esm["default"].h3.withConfig({
  displayName: "LandingFeaturesstyle__LandingFeaturesTitle",
  componentId: "sc-1m37zrn-1"
})(["font-family:\"Raleway\";font-style:normal;font-weight:500;font-size:40px;line-height:54px;color:#000000;margin-bottom:24px;"]);
var LandingFeaturesInfo = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFeaturesstyle__LandingFeaturesInfo",
  componentId: "sc-1m37zrn-2"
})(["font-family:\"Open Sans Light\",sans-serif;font-size:22px;line-height:30px;color:#4a4a4a;margin-bottom:24px;"]);
var LandingFeaturesList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "LandingFeaturesstyle__LandingFeaturesList",
  componentId: "sc-1m37zrn-3"
})(["font-size:18px;line-height:32px;padding-left:18px;gap:10px;& li{position:relative;background:linear-gradient(0deg,#000000,#000000),linear-gradient(93.66deg,#249083 0%,#249054 100%),#ffffff;-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;}& li:after{content:\"\";position:absolute;width:5px;height:14px;left:-18px;top:8px;background:#000000;border-radius:14px;}"]);
var PoweredByText = styled_components_browser_esm["default"].span.withConfig({
  displayName: "LandingFeaturesstyle__PoweredByText",
  componentId: "sc-1m37zrn-4"
})(["font-family:\"Open Sans Light\",sans-serif;font-weight:400;font-size:12px;line-height:16px;color:#000000;margin-right:20px;"]);
var Flex = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFeaturesstyle__Flex",
  componentId: "sc-1m37zrn-5"
})(["display:flex;align-items:center;"]);
var DataInfo = styled_components_browser_esm["default"].span.withConfig({
  displayName: "LandingFeaturesstyle__DataInfo",
  componentId: "sc-1m37zrn-6"
})(["width:326px;font-family:\"Open Sans\";color:#757575;margin:auto 0 16px;display:inline-block;"]);
var PoweredByLogo = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFeaturesstyle__PoweredByLogo",
  componentId: "sc-1m37zrn-7"
})(["margin:0 16px 0 0;"]);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/index.ts + 7 modules
var analytics = __webpack_require__(8217);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/LandingCurrDel/LandingCurrDel.style.ts
var LandingCurrDel_style = __webpack_require__(2434);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/Image/index.tsx + 1 modules
var Image = __webpack_require__(8863);
// EXTERNAL MODULE: ../../node_modules/react-markdown/lib/react-markdown.js + 137 modules
var react_markdown = __webpack_require__(843);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/LandingFeatures/LandingFeatures.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var LandingFeatures = function LandingFeatures(_ref) {
  var _data$poweredBy, _data$poweredBy2, _data$poweredBy2$logo, _data$cardImgs, _data$cardImgs2, _data$cardImgs3, _data$cardImgs4, _data$cardImgs5, _data$cardImgs6, _data$cardImgs7, _data$cardImgs8;

  var data = _ref.data,
      featureImgs = _ref.featureImgs;
  var router = (0,next_router.useRouter)();

  var clickHandler = function clickHandler() {
    if (data !== null && data !== void 0 && data.buyNowEvent) {
      (0,analytics/* pushEvent */.AB)(data.buyNowEvent);
    }

    if (data !== null && data !== void 0 && data.buttonRedirectionUrl) router.push(data.buttonRedirectionUrl);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFeaturesStyled, {
    id: "feat_ref",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingFeaturesTitle, {
      children: data.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFeaturesInfo, {
      dangerouslySetInnerHTML: {
        __html: data.info
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFeaturesList, {
      children: data.featList && data.featList.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: item
        }, index);
      })
    }), data.buttonTxt ? /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton/* default */.Z, {
      margin: "auto 0 30px",
      customTitle: data.buttonTxt,
      handleClick: clickHandler,
      padding: "12px 40px"
    }) : data.buttonFallbackText ? /*#__PURE__*/(0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
      children: data.buttonFallbackText
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Coming soon", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
    }), data.dataInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(DataInfo, {
      children: data.dataInfo
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingCurrDel_style/* FootNote */.Ob, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PoweredByText, {
        children: data === null || data === void 0 ? void 0 : (_data$poweredBy = data.poweredBy) === null || _data$poweredBy === void 0 ? void 0 : _data$poweredBy.title
      }), data === null || data === void 0 ? void 0 : (_data$poweredBy2 = data.poweredBy) === null || _data$poweredBy2 === void 0 ? void 0 : (_data$poweredBy2$logo = _data$poweredBy2.logos) === null || _data$poweredBy2$logo === void 0 ? void 0 : _data$poweredBy2$logo.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(PoweredByLogo, {
          children: /*#__PURE__*/(0,react.createElement)(Image/* Image */.E, _objectSpread(_objectSpread({}, item), {}, {
            key: index
          }))
        }, index);
      })]
    }), data.aniImg == "img1" && /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [/*#__PURE__*/(0,react.createElement)(Image/* Image */.E, _objectSpread(_objectSpread({
        id: "lug1_ref",
        width: "41",
        height: "148",
        className: "lug1"
      }, data === null || data === void 0 ? void 0 : (_data$cardImgs = data.cardImgs) === null || _data$cardImgs === void 0 ? void 0 : _data$cardImgs[0]), {}, {
        key: 0
      })), /*#__PURE__*/(0,react.createElement)(Image/* Image */.E, _objectSpread(_objectSpread({
        id: "lug2_ref",
        width: "70",
        height: "134",
        alt: "",
        className: "lug2"
      }, data === null || data === void 0 ? void 0 : (_data$cardImgs2 = data.cardImgs) === null || _data$cardImgs2 === void 0 ? void 0 : _data$cardImgs2[1]), {}, {
        key: 1
      })), /*#__PURE__*/(0,react.createElement)(Image/* Image */.E, _objectSpread(_objectSpread({
        id: "shield_ref",
        width: "85",
        height: "85",
        className: "shield"
      }, data === null || data === void 0 ? void 0 : (_data$cardImgs3 = data.cardImgs) === null || _data$cardImgs3 === void 0 ? void 0 : _data$cardImgs3[2]), {}, {
        key: 2
      })), /*#__PURE__*/(0,react.createElement)(Image/* Image */.E, _objectSpread(_objectSpread({
        id: "shieldRect_ref",
        width: "141",
        height: "28",
        className: "shieldRect"
      }, data === null || data === void 0 ? void 0 : (_data$cardImgs4 = data.cardImgs) === null || _data$cardImgs4 === void 0 ? void 0 : _data$cardImgs4[3]), {}, {
        key: 3
      }))]
    }), data.aniImg == "img2" && /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [/*#__PURE__*/(0,react.createElement)(Image/* Image */.E, _objectSpread(_objectSpread({
        id: "app1_ref",
        width: "120",
        height: "30",
        className: "app1"
      }, data === null || data === void 0 ? void 0 : (_data$cardImgs5 = data.cardImgs) === null || _data$cardImgs5 === void 0 ? void 0 : _data$cardImgs5[0]), {}, {
        key: 0
      })), /*#__PURE__*/(0,react.createElement)(Image/* Image */.E, _objectSpread(_objectSpread({
        id: "app2_ref",
        width: "130",
        height: "30",
        className: "app2"
      }, data === null || data === void 0 ? void 0 : (_data$cardImgs6 = data.cardImgs) === null || _data$cardImgs6 === void 0 ? void 0 : _data$cardImgs6[1]), {}, {
        key: 1
      })), /*#__PURE__*/(0,react.createElement)(Image/* Image */.E, _objectSpread(_objectSpread({
        id: "coins_ref",
        width: "67",
        height: "70",
        className: "coins"
      }, data === null || data === void 0 ? void 0 : (_data$cardImgs7 = data.cardImgs) === null || _data$cardImgs7 === void 0 ? void 0 : _data$cardImgs7[2]), {}, {
        key: 2
      })), /*#__PURE__*/(0,react.createElement)(Image/* Image */.E, _objectSpread(_objectSpread({
        id: "moneyBag_ref",
        width: "85",
        height: "116",
        className: "moneyBag"
      }, data === null || data === void 0 ? void 0 : (_data$cardImgs8 = data.cardImgs) === null || _data$cardImgs8 === void 0 ? void 0 : _data$cardImgs8[3]), {}, {
        key: 3
      }))]
    }), data.aniImg == "img1" && /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({
      width: "176",
      height: "135",
      className: "featureVector2"
    }, featureImgs === null || featureImgs === void 0 ? void 0 : featureImgs[0])), data.aniImg == "img2" && /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({
      width: "208",
      height: "135",
      className: "featureVector"
    }, featureImgs === null || featureImgs === void 0 ? void 0 : featureImgs[1]))]
  });
};

/* harmony default export */ var LandingFeatures_LandingFeatures = (LandingFeatures);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/insuranceSection/index.style.tsx

var index_style_Flex = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexstyle__Flex",
  componentId: "cdpzop-0"
})(["display:flex;gap:20px;margin-bottom:16px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/insuranceSection/index.tsx







var InsuranceSection = function InsuranceSection(props) {
  (0,hooks/* useInsuranaceAnimation */.$D)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(shared_styled_components/* LandingGreySec */.zq, {
    padding: "0 0 80px 0",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(shared_styled_components/* LandingGreySecWrap */.kj, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_style_Flex, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingFeatures_LandingFeatures, {
          featRef: props === null || props === void 0 ? void 0 : props.featRef,
          lug1: props === null || props === void 0 ? void 0 : props.lug1,
          lug2: props === null || props === void 0 ? void 0 : props.lug2,
          shield: props === null || props === void 0 ? void 0 : props.shield,
          shieldRect: props === null || props === void 0 ? void 0 : props.shieldRect,
          data: props === null || props === void 0 ? void 0 : props.insurance,
          featureImgs: props === null || props === void 0 ? void 0 : props.featureImgs
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFeatures_LandingFeatures, {
          featRef: props === null || props === void 0 ? void 0 : props.featRef,
          app1: props === null || props === void 0 ? void 0 : props.app1,
          app2: props === null || props === void 0 ? void 0 : props.app2,
          moneyBag: props === null || props === void 0 ? void 0 : props.moneyBag,
          coins: props === null || props === void 0 ? void 0 : props.coins,
          data: props === null || props === void 0 ? void 0 : props.travelLoan,
          featureImgs: props === null || props === void 0 ? void 0 : props.featureImgs
        })]
      })
    })
  });
};

/* harmony default export */ var insuranceSection = (InsuranceSection);

/***/ })

}]);